module.exports = __webpack_public_path__ + "img/ico_sjcj.36068937.png";